import { OrderPaymentProvider } from "../common/order-payment-kind";

export class OrderPaymentDTO {
	public id: number;
	public externalId: string;
	public finishedAt: Date;
	public provider: OrderPaymentProvider;
	public currencyExternalId: string;
	public amount: number;
}